import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ServiceDeskPortalSettingsRelayQuery, {
	type ServiceDeskPortalSettingsQuery,
} from '@atlassian/jira-relay/src/__generated__/ServiceDeskPortalSettingsQuery.graphql';

export const serviceDeskPortalSettingsResource =
	createRelayResource<ServiceDeskPortalSettingsQuery>({
		type: `${RELAY_RESOURCE_TYPE}_SERVICE_DESK_PORTAL_SETTINGS`,
		getQuery: (_, { tenantContext: { cloudId } }) => ({
			parameters: ServiceDeskPortalSettingsRelayQuery,
			variables: { cloudIdString: cloudId, cloudId },
			options: { fetchPolicy: 'store-and-network' },
		}),
		isCritical: true,
	});
